import React, { useContext, useState } from 'react';
import { FlowContext } from '../../core/flow-engine';
import { RewardsContext } from '../../context/RewardsContext/RewardsContext';
import style from './style.css';
import AllocationSection from '../../components/AllocationSection/AllocationSection';
import {
  CartContextProvider,
  CartContext
} from '../../context/CartContext/CartContext';
import BuildPortfolioHeader from '../../components/BuildPortfolioHeader/BuildPortfolioHeader';
import BYOPLegal from '../../components/BYOPLegal/BYOPLegal';
import FundListFragment from '../../components/FundListFragment/FundListFragment';
import PhoneNumber from '../../components/PhoneNumber/PhoneNumber';
import { MFBeaconButton } from '../../components/Beacon/BeaconComponents';
import { formatFunds, autoSplitPercents } from '../../flows/shared/utils';
import { getRewardsAvailable } from '../../flows/shared/summit.utils';
import FundLaterFundSection from '../../components/AllocationSection/v2/FundLaterFundSection';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';

const BYOPScreenContents = () => {
  const { appState, next, flowProps } = useContext(FlowContext);
  const { selectedFunds } = useContext(CartContext);

  const [headerOpen, toggleHeader] = useState(false);
  const [filterOpen, toggleFilter] = useState(false);

  const { currentTier = 0 } = useContext(RewardsContext) || {};

  const {
    store: { app, accountType, amount, inReviewMode }
  } = appState;

  const { fundLaterFlow = false } = flowProps;

  const rewardsAvailable = getRewardsAvailable(
    accountType,
    app?.trust,
    app?.trustee,
    currentTier
  );

  return (
    <div className="byop-screen" data-name="byopScreenConainer">
      <BuildPortfolioHeader amount={amount} />
      {fundLaterFlow ? (
        <FundLaterFundSection
          headerOpen={headerOpen}
          toggleHeader={toggleHeader}
          filterOpen={filterOpen}
          rewardsAvailable={rewardsAvailable}
          amount={amount}
        />
      ) : (
        <AllocationSection
          headerOpen={headerOpen}
          toggleHeader={toggleHeader}
          filterOpen={filterOpen}
          rewardsAvailable={rewardsAvailable}
        />
      )}
      <FundListFragment
        filterOpen={filterOpen}
        toggleFilter={toggleFilter}
        headerOpen={headerOpen}
        rewardsAvailable={rewardsAvailable}
      />
      <div className="btn-container">
        {!inReviewMode && (
          <MFBeaconButton
            id="BYOPBack"
            variant="secondary"
            size="normal"
            className="beacon-button-margin-override"
            onClick={next(selectedFunds, 'updateAndBack')}
            label="Back"
            data-name={generateGeneralTestID('BYOP', 'BackButton')}
          />
        )}
      </div>
      <PhoneNumber />
      <BYOPLegal />
      <style jsx>{style}</style>
    </div>
  );
};

const BYOPScreen = ({ appState }) => {
  const {
    store: { chosenInvestments = [], amount, loadedData = {} }
  } = appState;

  const funds =
    !chosenInvestments?.length && loadedData.shoppingFunds
      ? autoSplitPercents(loadedData.shoppingFunds, amount)
      : autoSplitPercents(chosenInvestments, amount);

  const formattedSelectedFunds = formatFunds(funds);

  return (
    <CartContextProvider
      initialTotalAmount={amount}
      initialPercentMode
      initialFunds={formattedSelectedFunds}>
      <BYOPScreenContents />
    </CartContextProvider>
  );
};

export default BYOPScreen;
